import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { assertNever } from '../utils/assert-never';
import { BeaconMessageType } from '..';
import { BEACON_VERSION } from '../constants';
import { getAddressFromPublicKey } from '../utils/crypto';
import { getAccountIdentifier } from '../utils/get-account-identifier';
import { BeaconErrorType } from '../types/BeaconErrorType';
import { Logger } from '../utils/Logger';
var logger = new Logger('OutgoingResponseInterceptor');
/**
 * @internalapi
 *
 * The OutgoingResponseInterceptor is used in the WalletClient to intercept an outgoing response and enrich it with data.
 */

export var OutgoingResponseInterceptor = /*#__PURE__*/function () {
  function OutgoingResponseInterceptor() {
    _classCallCheck(this, OutgoingResponseInterceptor);
  }

  _createClass(OutgoingResponseInterceptor, null, [{
    key: "intercept",
    value: function intercept(config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var senderId, request, message, ownAppMetadata, permissionManager, appMetadataManager, interceptorCallback, interceptorCallbackWrapper, response, errorData, _response, _response2, publicKey, address, appMetadata, permission, _response3, _response4, _response5;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                senderId = config.senderId, request = config.request, message = config.message, ownAppMetadata = config.ownAppMetadata, permissionManager = config.permissionManager, appMetadataManager = config.appMetadataManager, interceptorCallback = config.interceptorCallback; // TODO: Remove v1 compatibility in later version

                interceptorCallbackWrapper = function interceptorCallbackWrapper(msg) {
                  var untypedMessage = msg;
                  untypedMessage.beaconId = msg.senderId;
                  interceptorCallback(msg);
                };

                _context.t0 = message.type;
                _context.next = _context.t0 === BeaconMessageType.Error ? 5 : _context.t0 === BeaconMessageType.Acknowledge ? 9 : _context.t0 === BeaconMessageType.PermissionResponse ? 12 : _context.t0 === BeaconMessageType.OperationResponse ? 36 : _context.t0 === BeaconMessageType.SignPayloadResponse ? 39 : _context.t0 === BeaconMessageType.BroadcastResponse ? 42 : 45;
                break;

              case 5:
                response = {
                  type: message.type,
                  version: BEACON_VERSION,
                  senderId: senderId,
                  id: message.id,
                  errorType: message.errorType
                };

                if (message.errorType === BeaconErrorType.TRANSACTION_INVALID_ERROR && message.errorData) {
                  errorData = message.errorData; // Check if error data is in correct format

                  if (Array.isArray(errorData) && errorData.every(function (item) {
                    return Boolean(item.kind) && Boolean(item.id);
                  })) {
                    response.errorData = message.errorData;
                  } else {
                    logger.warn('ErrorData provided is not in correct format. It needs to be an array of RPC errors. It will not be included in the message sent to the dApp');
                  }
                }

                interceptorCallbackWrapper(response);
                return _context.abrupt("break", 47);

              case 9:
                _response = {
                  type: message.type,
                  version: BEACON_VERSION,
                  senderId: senderId,
                  id: message.id
                };
                interceptorCallbackWrapper(_response);
                return _context.abrupt("break", 47);

              case 12:
                _response2 = Object.assign({
                  senderId: senderId,
                  version: BEACON_VERSION,
                  appMetadata: ownAppMetadata
                }, message); // TODO: Migration code. Remove sometime after 1.0.0 release.

                publicKey = _response2.publicKey || _response2.pubkey || _response2.pubKey;
                _context.next = 16;
                return getAddressFromPublicKey(publicKey);

              case 16:
                address = _context.sent;
                _context.next = 19;
                return appMetadataManager.getAppMetadata(request.senderId);

              case 19:
                appMetadata = _context.sent;

                if (appMetadata) {
                  _context.next = 22;
                  break;
                }

                throw new Error('AppMetadata not found');

              case 22:
                _context.next = 24;
                return getAccountIdentifier(address, _response2.network);

              case 24:
                _context.t1 = _context.sent;
                _context.t2 = request.senderId;
                _context.t3 = appMetadata;
                _context.t4 = address;
                _context.t5 = publicKey;
                _context.t6 = _response2.network;
                _context.t7 = _response2.scopes;
                _context.t8 = new Date().getTime();
                permission = {
                  accountIdentifier: _context.t1,
                  senderId: _context.t2,
                  appMetadata: _context.t3,
                  website: '',
                  address: _context.t4,
                  publicKey: _context.t5,
                  network: _context.t6,
                  scopes: _context.t7,
                  connectedAt: _context.t8
                };
                permissionManager.addPermission(permission).catch(console.error);
                interceptorCallbackWrapper(_response2);
                return _context.abrupt("break", 47);

              case 36:
                _response3 = Object.assign({
                  senderId: senderId,
                  version: BEACON_VERSION
                }, message);
                interceptorCallbackWrapper(_response3);
                return _context.abrupt("break", 47);

              case 39:
                _response4 = Object.assign({
                  senderId: senderId,
                  version: BEACON_VERSION
                }, message);
                interceptorCallbackWrapper(_response4);
                return _context.abrupt("break", 47);

              case 42:
                _response5 = Object.assign({
                  senderId: senderId,
                  version: BEACON_VERSION
                }, message);
                interceptorCallbackWrapper(_response5);
                return _context.abrupt("break", 47);

              case 45:
                logger.log('intercept', 'Message not handled');
                assertNever(message);

              case 47:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }]);

  return OutgoingResponseInterceptor;
}();